// prettier-ignore
export const SpecElemsActionTypes = {
  SET_ELEMENT_PRESENT: 'SET_ELEMENT_PRESENT',
  SET_ELEMENT_ABSENT: 'SET_ELEMENT_ABSENT',
  RESET_ALL_ELEMENTS: 'RESET_ALL_ELEMENTS'
};
